export default [
    {
        logoId: 1,
        name: "Contagem Regressiva",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 33,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 10 de dano físico  e explode no corpo do inimigo causando 51 de dano adicional após 3 segundos.",
                necessaryLevel: 1,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 43,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 13 de dano físico  e explode no corpo do inimigo causando 66 de dano adicional após 3 segundos.",
                necessaryLevel: 4,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 57,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 17 de dano físico  e explode no corpo do inimigo causando 88 de dano adicional após 3 segundos.",
                necessaryLevel: 8,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 72,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 22 de dano físico  e explode no corpo do inimigo causando 111 de dano adicional após 3 segundos.",
                necessaryLevel: 12,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 90,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 28 de dano físico  e explode no corpo do inimigo causando 138 de dano adicional após 3 segundos.",
                necessaryLevel: 16,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 112,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 35 de dano físico  e explode no corpo do inimigo causando 173 de dano adicional após 3 segundos.",
                necessaryLevel: 20,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 137,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 42 de dano físico  e explode no corpo do inimigo causando 210 de dano adicional após 3 segundos.",
                necessaryLevel: 24,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 164,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 51 de dano físico  e explode no corpo do inimigo causando 253 de dano adicional após 3 segundos.",
                necessaryLevel: 28,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 201,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 62 de dano físico  e explode no corpo do inimigo causando 309 de dano adicional após 3 segundos.",
                necessaryLevel: 32,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 244,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 75 de dano físico  e explode no corpo do inimigo causando 375 de dano adicional após 3 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 293,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 90 de dano físico  e explode no corpo do inimigo causando 451 de dano adicional após 3 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 346,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 107 de dano físico  e explode no corpo do inimigo causando 533 de dano adicional após 3 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 408,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 126 de dano físico  e explode no corpo do inimigo causando 628 de dano adicional após 3 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 474,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 146 de dano físico  e explode no corpo do inimigo causando 729 de dano adicional após 3 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 549,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 169 de dano físico  e explode no corpo do inimigo causando 844 de dano adicional após 3 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 630,
                cast: 1,
                info:
                    "Atira uma bala especial que causa 194 de dano físico  e explode no corpo do inimigo causando 969 de dano adicional após 3 segundos.",
                necessaryLevel: 60,
            },
        ],
    },
    {
        logoId: 2,
        name: "Tiro Fatal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 34,
                cast: 0,
                info:
                    "Causa 47 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 57 e resistência a status anormais em 10 por 20 segundos.",
                necessaryLevel: 4,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 45,
                cast: 0,
                info:
                    "Causa 63 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 77 e resistência a status anormais em 12 por 20 segundos.",
                necessaryLevel: 8,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 57,
                cast: 0,
                info:
                    "Causa 79 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 98 e resistência a status anormais em 14 por 20 segundos.",
                necessaryLevel: 12,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 70,
                cast: 0,
                info:
                    "Causa 98 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 121 e resistência a status anormais em 16 por 20 segundos.",
                necessaryLevel: 16,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 88,
                cast: 0,
                info:
                    "Causa 123 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 155 e resistência a status anormais em 18 por 20 segundos.",
                necessaryLevel: 20,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 107,
                cast: 0,
                info:
                    "Causa 150 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 193 e resistência a status anormais em 20 por 20 segundos.",
                necessaryLevel: 24,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 129,
                cast: 0,
                info:
                    "Causa 181 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 233 e resistência a status anormais em 22 por 20 segundos.",
                necessaryLevel: 28,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 157,
                cast: 0,
                info:
                    "Causa 221 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 283 e resistência a status anormais em 24 por 20 segundos.",
                necessaryLevel: 32,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 190,
                cast: 0,
                info:
                    "Causa 268 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 343 e resistência a status anormais em 26 por 20 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 229,
                cast: 0,
                info:
                    "Causa 322 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 413 e resistência a status anormais em 28 por 20 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 271,
                cast: 0,
                info:
                    "Causa 381 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 487 e resistência a status anormais em 30 por 20 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 319,
                cast: 0,
                info:
                    "Causa 448 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 575 e resistência a status anormais em 32 por 20 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 370,
                cast: 0,
                info:
                    "Causa 520 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 685 e resistência a status anormais em 34 por 20 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 429,
                cast: 0,
                info:
                    "Causa 603 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 802 e resistência a status anormais em 36 por 20 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 490,
                cast: 0,
                info:
                    "Causa 692 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 923 e resistência a status anormais em 38 por 20 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 553,
                cast: 0,
                info:
                    "Causa 778 de dano físico em um inimigo e expõe suas fraquezas diminuindo sua defesa física em 1051 e resistência a status anormais em 40 por 20 segundos.",
                necessaryLevel: 64,
            },
        ],
    },
    {
        logoId: 3,
        name: "Tiro Angular",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 80,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 154 de dano físico no alvo e aumenta a taxa de crítico da skill em 25.",
                necessaryLevel: 6,
            },
            {
                level: 2,
                cooldown: 11,
                mp: 104,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 200 de dano físico no alvo e aumenta a taxa de crítico da skill em 27.",
                necessaryLevel: 10,
            },
            {
                level: 3,
                cooldown: 10,
                mp: 130,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 250 de dano físico no alvo e aumenta a taxa de crítico da skill em 29.",
                necessaryLevel: 14,
            },
            {
                level: 4,
                cooldown: 9,
                mp: 163,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 313 de dano físico no alvo e aumenta a taxa de crítico da skill em 31.",
                necessaryLevel: 18,
            },
            {
                level: 5,
                cooldown: 8,
                mp: 202,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 388 de dano físico no alvo e aumenta a taxa de crítico da skill em 33.",
                necessaryLevel: 22,
            },
            {
                level: 6,
                cooldown: 7,
                mp: 243,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 467 de dano físico no alvo e aumenta a taxa de crítico da skill em 35.",
                necessaryLevel: 26,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 295,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 567 de dano físico no alvo e aumenta a taxa de crítico da skill em 37.",
                necessaryLevel: 30,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 358,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 688 de dano físico no alvo e aumenta a taxa de crítico da skill em 39.",
                necessaryLevel: 34,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 433,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 833 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 41.",
                necessaryLevel: 38,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 516,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 992 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 43.",
                necessaryLevel: 42,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 607,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 1167 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 45.",
                necessaryLevel: 46,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 713,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 1371 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 47.",
                necessaryLevel: 50,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 826,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 1588 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 49.",
                necessaryLevel: 54,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 954,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 1834 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 51.",
                necessaryLevel: 58,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 1084,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 2084 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 53.",
                necessaryLevel: 62,
            },
            {
                level: 16,
                mp: 1218,
                cast: 1,
                info:
                    "Dispara um  tiro destinado a infligir 2342 de dano físico no alvo e em alvos na trajetória da bala e aumenta a taxa de crítico da skill em 55.",
                necessaryLevel: 66,
            },
        ],
    },
    {
        logoId: 4,
        name: "Tiro na Perna",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 46,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 65 pontos e reduzindo a movimentação durante 10 segundos em 15 pontos.",
                necessaryLevel: 8,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 57,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 81 pontos e reduzindo a movimentação durante 11 segundos em 18 pontos.",
                necessaryLevel: 12,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 71,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 101 pontos e reduzindo a movimentação durante 12 segundos em 21 pontos.",
                necessaryLevel: 16,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 88,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 126 pontos e reduzindo a movimentação durante 13 segundos em 24 pontos.",
                necessaryLevel: 20,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 107,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 153 pontos e reduzindo a movimentação durante 14 segundos em 27 pontos.",
                necessaryLevel: 24,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 130,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 185 pontos e reduzindo a movimentação durante 15 segundos em 30 pontos.",
                necessaryLevel: 28,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 158,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 225 pontos e reduzindo a movimentação durante 16 segundos em 33 pontos.",
                necessaryLevel: 32,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 191,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 273 pontos e reduzindo a movimentação durante 17 segundos em 36 pontos.",
                necessaryLevel: 36,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 230,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 329 pontos e reduzindo a movimentação durante 18 segundos em 39 pontos.",
                necessaryLevel: 40,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 272,
                cast: 0,
                info:
                    "Ataca as pernas do inimigo causando um dano físico de 389 pontos e reduzindo a movimentação durante 20 segundos em 42 pontos.",
                necessaryLevel: 44,
            },
        ],
    },
    {
        logoId: 5,
        name: "Ocultar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 23,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 30 segundos reinicializando a taxa de perigo porém reduz a movimentação em 20 pontos.",
                necessaryLevel: 10,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 29,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 33 segundos reinicializando a taxa de perigo porém reduz a movimentação em 15 pontos.",
                necessaryLevel: 14,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 35,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 36 segundos reinicializando a taxa de perigo porém reduz a movimentação em 10 pontos.",
                necessaryLevel: 18,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 43,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 39 segundos reinicializando a taxa de perigo porém reduz a movimentação em 5 pontos.",
                necessaryLevel: 22,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 51,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 42 segundos reinicializando a taxa de perigo.",
                necessaryLevel: 26,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 61,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 45 segundos reinicializando a taxa de perigo porém reduz a movimentação em 2 pontos.",
                necessaryLevel: 30,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 74,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 48 segundos reinicializando a taxa de perigo porém reduz a movimentação em 4 pontos.",
                necessaryLevel: 34,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 88,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 51 segundos reinicializando a taxa de perigo porém reduz a movimentação em 6 pontos.",
                necessaryLevel: 38,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 104,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 54 segundos reinicializando a taxa de perigo porém reduz a movimentação em 8 pontos.",
                necessaryLevel: 42,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 122,
                cast: 0,
                info:
                    "Se oculta entre as sombras durante 60 segundos reinicializando a taxa de perigo porém reduz a movimentação em 10 pontos.",
                necessaryLevel: 46,
            },
        ],
    },
    {
        logoId: 6,
        name: "Najmum",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 77,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 57 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 5% mais chance de serem atingidas.",
                necessaryLevel: 12,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 95,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 71 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 8% mais chance de serem atingidas.",
                necessaryLevel: 16,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 117,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 89 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 11% mais chance de serem atingidas.",
                necessaryLevel: 20,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 140,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 109 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 14% mais chance de serem atingidas.",
                necessaryLevel: 24,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 168,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 131 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 17% mais chance de serem atingidas.",
                necessaryLevel: 28,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 202,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 160 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 20% mais chance de serem atingidas.",
                necessaryLevel: 32,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 242,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 194 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 23% mais chance de serem atingidas.",
                necessaryLevel: 36,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 289,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 233 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 26% mais chance de serem atingidas.",
                necessaryLevel: 40,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 338,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 276 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 29% mais chance de serem atingidas.",
                necessaryLevel: 44,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 394,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 325 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 32% mais chance de serem atingidas.",
                necessaryLevel: 48,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 453,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 377 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 35% mais chance de serem atingidas.",
                necessaryLevel: 52,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 520,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 436 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 38% mais chance de serem atingidas.",
                necessaryLevel: 56,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 591,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 498 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 41% mais chance de serem atingidas.",
                necessaryLevel: 60,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 658,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 563 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 44% mais chance de serem atingidas.",
                necessaryLevel: 64,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 732,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 633 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 47% mais chance de serem atingidas.",
                necessaryLevel: 68,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 814,
                cast: 1,
                info:
                    "Aumenta habilidade de ataque em 712 pontos durante 10 minutos e suas habilidades que possuem tempo de lançamento maior que 1 segundo possuem 50% mais chance de serem atingidas.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 7,
        name: "Perseguidor Implacável",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 132,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 66 de dano físico por segundo e diminuindo a capacidade de cura em 50%.",
                necessaryLevel: 17,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 162,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 81 de dano físico por segundo e diminuindo a capacidade de cura em 52%.",
                necessaryLevel: 21,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 196,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 98 de dano físico por segundo e diminuindo a capacidade de cura em 54%.",
                necessaryLevel: 25,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 240,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 120 de dano físico por segundo e diminuindo a capacidade de cura em 56%.",
                necessaryLevel: 29,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 290,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 145 de dano físico por segundo e diminuindo a capacidade de cura em 58%.",
                necessaryLevel: 33,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 352,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 176 de dano físico por segundo e diminuindo a capacidade de cura em 60%.",
                necessaryLevel: 37,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 420,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 210 de dano físico por segundo e diminuindo a capacidade de cura em 62%.",
                necessaryLevel: 41,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 494,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 247 de dano físico por segundo e diminuindo a capacidade de cura em 64%.",
                necessaryLevel: 45,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 584,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 292 de dano físico por segundo e diminuindo a capacidade de cura em 66%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 49,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 676,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 338 de dano físico por segundo e diminuindo a capacidade de cura em 68%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 53,
            },
            {
                level: 11,
                cooldown: 6,
                mp: 782,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 391 de dano físico por segundo e diminuindo a capacidade de cura em 70%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 57,
            },
            {
                level: 12,
                cooldown: 6,
                mp: 892,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 446 de dano físico por segundo e diminuindo a capacidade de cura em 72%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 61,
            },
            {
                level: 13,
                cooldown: 6,
                mp: 1004,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 502 de dano físico por segundo e diminuindo a capacidade de cura em 74%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 65,
            },
            {
                level: 14,
                cooldown: 6,
                mp: 1128,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 564 de dano físico por segundo e diminuindo a capacidade de cura em 76%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 69,
            },
            {
                level: 15,
                cooldown: 6,
                mp: 1270,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 635 de dano físico por segundo e diminuindo a capacidade de cura em 78%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 73,
            },
            {
                level: 16,
                cooldown: 6,
                mp: 1414,
                cast: 0,
                info:
                    "Faz um inimigo sangrar durante 6 segundos, infligindo 707 de dano físico por segundo e diminuindo a capacidade de cura em 80%. O alvo fica impossibilitado de receber purificação.",
                necessaryLevel: 77,
            },
        ],
    },
    {
        logoId: 8,
        name: "Precisão",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 74,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 5 pontos e o crítico em 3 pontos.",
                necessaryLevel: 19,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 90,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 6 pontos e o crítico em 6 pontos.",
                necessaryLevel: 23,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 108,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 7 pontos e o crítico em 9 pontos.",
                necessaryLevel: 27,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 129,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 8 pontos e o crítico em 12 pontos.",
                necessaryLevel: 31,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 155,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 9 pontos e o crítico em 15 pontos.",
                necessaryLevel: 35,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 185,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 10 pontos e o crítico em 18 pontos.",
                necessaryLevel: 39,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 217,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 11 pontos e o crítico em 21 pontos.",
                necessaryLevel: 43,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 253,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 12 pontos e o crítico em 24 pontos.",
                necessaryLevel: 47,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 292,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 13 pontos e o crítico em 27 pontos.",
                necessaryLevel: 51,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 335,
                cast: 1,
                info:
                    "Durante 1 minuto aumenta a precisão em 15 pontos e o crítico em 30 pontos.",
                necessaryLevel: 55,
            },
        ],
    },
    {
        logoId: 9,
        name: "Concentração",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 20% ao receber um ataque e aumenta a precisão em 2 pts.",
                necessaryLevel: 21,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 32% ao receber um ataque e aumenta a precisão em 4 pts.",
                necessaryLevel: 25,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 44% ao receber um ataque e aumenta a precisão em 6 pts.",
                necessaryLevel: 29,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 52% ao receber um ataque e aumenta a precisão em 8 pts.",
                necessaryLevel: 33,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 60% ao receber um ataque e aumenta a precisão em 10 pts.",
                necessaryLevel: 37,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 68% ao receber um ataque e aumenta a precisão em 12 pts.",
                necessaryLevel: 41,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 76% ao receber um ataque e aumenta a precisão em 14 pts.",
                necessaryLevel: 45,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 84% ao receber um ataque e aumenta a precisão em 16 pts.",
                necessaryLevel: 49,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 92% ao receber um ataque e aumenta a precisão em 18 pts.",
                necessaryLevel: 53,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a probabilidade de resistir o cancelamento de habilidades em 100% ao receber um ataque e aumenta a precisão em 20 pts.",
                necessaryLevel: 57,
            },
        ],
    },
    {
        logoId: 10,
        name: "Poder Crítico",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 10%.",
                necessaryLevel: 23,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 15%.",
                necessaryLevel: 27,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 20%.",
                necessaryLevel: 31,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 25%.",
                necessaryLevel: 35,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 30%.",
                necessaryLevel: 39,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 35%.",
                necessaryLevel: 43,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 40%.",
                necessaryLevel: 47,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 45%.",
                necessaryLevel: 51,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 50%.",
                necessaryLevel: 55,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info: "Aumenta o dano aplicado durante os críticos em 55%.",
                necessaryLevel: 59,
            },
        ],
    },
    {
        logoId: 11,
        name: "Detonação",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 123,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 187 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 25,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 150,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 228 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 29,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 182,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 277 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 33,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 220,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 334 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 37,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 262,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 399 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 41,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 310,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 471 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 45,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 366,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 555 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 49,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 422,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 642 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 53,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 490,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 744 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 57,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 558,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 849 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 61,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 629,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 956 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 65,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 706,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 1073 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 69,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 795,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 1208 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 73,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 885,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 1344 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 77,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 984,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 1495 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 81,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 1091,
                cast: 0,
                info:
                    "Atira um projétil especial no local, dando um dano de 1659 nos alvos dentro de uma área de 4M e silencia por 3 segundos.",
                necessaryLevel: 85,
            },
        ],
    },
    {
        logoId: 12,
        name: "Primeiro Encontro",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 106,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 327 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 27,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 128,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 393 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 31,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 155,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 476 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 35,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 188,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 578 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 39,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 222,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 682 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 43,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 261,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 803 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 47,
            },
            {
                level: 7,
                cooldown: 60,
                mp: 305,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 938 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 8,
                cooldown: 60,
                mp: 353,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 1086 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 9,
                cooldown: 60,
                mp: 409,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 1245 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 10,
                cooldown: 60,
                mp: 460,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 1416 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 11,
                cooldown: 60,
                mp: 517,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 1590 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 12,
                cooldown: 60,
                mp: 582,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 1790 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 13,
                cooldown: 60,
                mp: 652,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 2005 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 14,
                cooldown: 60,
                mp: 723,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 2225 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 15,
                cooldown: 60,
                mp: 804,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 2475 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 16,
                cooldown: 60,
                mp: 893,
                cast: 0,
                info:
                    "Com a habilidade de ocultar ativada, causa um dano físico de 2747 aos inimigos, atacando de surpresa e paralizando durante 5 segundos.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 13,
        name: "Eliminar Alvo",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 128,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 525 pontos.",
                necessaryLevel: 32,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 155,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 637 pontos.",
                necessaryLevel: 36,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 187,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 767 pontos.",
                necessaryLevel: 40,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 221,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 907 pontos.",
                necessaryLevel: 44,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 260,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 1068 pontos.",
                necessaryLevel: 48,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 302,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 1239 pontos.",
                necessaryLevel: 52,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 350,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 1435 pontos.",
                necessaryLevel: 56,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 402,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 1638 pontos.",
                necessaryLevel: 60,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 452,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 1852 pontos.",
                necessaryLevel: 64,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 508,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 2083 pontos.",
                necessaryLevel: 68,
            },
            {
                level: 11,
                cooldown: 3,
                mp: 571,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 2342 pontos.",
                necessaryLevel: 72,
            },
            {
                level: 12,
                cooldown: 3,
                mp: 639,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 2622 pontos.",
                necessaryLevel: 76,
            },
            {
                level: 13,
                cooldown: 3,
                mp: 709,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 2909 pontos.",
                necessaryLevel: 80,
            },
            {
                level: 14,
                cooldown: 3,
                mp: 788,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 3234 pontos.",
                necessaryLevel: 84,
            },
            {
                level: 15,
                cooldown: 3,
                mp: 875,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 3591 pontos.",
                necessaryLevel: 88,
            },
            {
                level: 16,
                cooldown: 3,
                mp: 972,
                cast: 0,
                info:
                    "Atira em um alvo com o HP abaixo de 25% causando um dano físico de 3987 pontos.",
                necessaryLevel: 92,
            },
        ],
    },
    {
        logoId: 14,
        name: "Rajada Sônica",
        levelsInfo: [
            {
                level: 1,
                cooldown: 30,
                mp: 260,
                cast: 3,
                info:
                    "Atira e causa 618 de dano físico num raio de 4M, além de silenciá-los por 6 segundos. A skill possui uma taxa de crítico adicional de 25.",
                necessaryLevel: 34,
            },
            {
                level: 2,
                cooldown: 29,
                mp: 315,
                cast: 3,
                info:
                    "Atira e causa 749 de dano físico num raio de 4M, além de silenciá-los por 6 segundos. A skill possui uma taxa de crítico adicional de 27.",
                necessaryLevel: 38,
            },
            {
                level: 3,
                cooldown: 28,
                mp: 374,
                cast: 3,
                info:
                    "Atira e causa 891 de dano físico num raio de 4M, além de silenciá-los por 6 segundos. A skill possui uma taxa de crítico adicional de 29.",
                necessaryLevel: 42,
            },
            {
                level: 4,
                cooldown: 27,
                mp: 440,
                cast: 3,
                info:
                    "Atira e causa 1048 de dano físico num raio de 4M, além de silenciá-los por 7 segundos. A skill possui uma taxa de crítico adicional de 31.",
                necessaryLevel: 46,
            },
            {
                level: 5,
                cooldown: 26,
                mp: 517,
                cast: 3,
                info:
                    "Atira e causa 1232 de dano físico num raio de 4M, além de silenciá-los por 7 segundos. A skill possui uma taxa de crítico adicional de 33.",
                necessaryLevel: 50,
            },
            {
                level: 6,
                cooldown: 25,
                mp: 599,
                cast: 3,
                info:
                    "Atira e causa 1426 de dano físico num raio de 4M, além de silenciá-los por 7 segundos. A skill possui uma taxa de crítico adicional de 35.",
                necessaryLevel: 54,
            },
            {
                level: 7,
                cooldown: 24,
                mp: 692,
                cast: 3,
                info:
                    "Atira e causa 1651 de dano físico num raio de 4M, além de silenciá-los por 8 segundos. A skill possui uma taxa de crítico adicional de 37.",
                necessaryLevel: 58,
            },
            {
                level: 8,
                cooldown: 23,
                mp: 786,
                cast: 3,
                info:
                    "Atira e causa 1872 de dano físico num raio de 4M, além de silenciá-los por 8 segundos. A skill possui uma taxa de crítico adicional de 39",
                necessaryLevel: 62,
            },
            {
                level: 9,
                cooldown: 22,
                mp: 884,
                cast: 3,
                info:
                    "Atira e causa 2104 de dano físico num raio de 4M, além de silenciá-los por 8 segundos. A skill possui uma taxa de crítico adicional de 41.",
                necessaryLevel: 66,
            },
            {
                level: 10,
                cooldown: 21,
                mp: 992,
                cast: 3,
                info:
                    "Atira e causa 2362 de dano físico num raio de 4M, além de silenciá-los por 9 segundos. A skill possui uma taxa de crítico adicional de 43.",
                necessaryLevel: 70,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 1115,
                cast: 3,
                info:
                    "Atira e causa 2658 de dano físico num raio de 4M, além de silenciá-los por 9 segundos. A skill possui uma taxa de crítico adicional de 45.",
                necessaryLevel: 74,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 1239,
                cast: 3,
                info:
                    "Atira e causa 2950 de dano físico num raio de 4M, além de silenciá-los por 9 segundos. A skill possui uma taxa de crítico adicional de 47.",
                necessaryLevel: 78,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 1378,
                cast: 3,
                info:
                    "Atira e causa 3280 de dano físico num raio de 4M, além de silenciá-los por 10 segundos. A skill possui uma taxa de crítico adicional de 49.",
                necessaryLevel: 82,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 1530,
                cast: 3,
                info:
                    "Atira e causa 3643 de dano físico num raio de 4M, além de silenciá-los por 10 segundos. A skill possui uma taxa de crítico adicional de 51.",
                necessaryLevel: 86,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 1700,
                cast: 3,
                info:
                    "Atira e causa 4047 de dano físico num raio de 4M, além de silenciá-los por 10 segundos. A skill possui uma taxa de crítico adicional de 53.",
                necessaryLevel: 90,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 1889,
                cast: 3,
                info:
                    "Atira e causa 4497 de dano físico num raio de 4M, além de silenciá-los por 10 segundos. A skill possui uma taxa de crítico adicional de 55.",
                necessaryLevel: 94,
            },
        ],
    },
    {
        logoId: 15,
        name: "Ponto Vital",
        levelsInfo: [
            {
                level: 1,
                cooldown: 30,
                mp: 66,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 182 e o mantém em estado de choque durante 6 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 2,
                cooldown: 30,
                mp: 80,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 219 e o mantém em estado de choque durante 7 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 3,
                cooldown: 30,
                mp: 94,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 259 e o mantém em estado de choque durante 8 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 4,
                cooldown: 30,
                mp: 111,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 305 e o mantém em estado de choque durante 9 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 5,
                cooldown: 30,
                mp: 129,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 354 e o mantém em estado de choque durante 10 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 6,
                cooldown: 30,
                mp: 149,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 410 e o mantém em estado de choque durante 11 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 7,
                cooldown: 30,
                mp: 169,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 468 e o mantém em estado de choque durante 12 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 8,
                cooldown: 30,
                mp: 192,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 529 e o mantém em estado de choque durante 13 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 9,
                cooldown: 30,
                mp: 216,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 595 e o mantém em estado de choque durante 14 segundos.",
                necessaryLevel: 68,
            },
            {
                level: 10,
                cooldown: 30,
                mp: 243,
                cast: 0,
                info:
                    "Ataca um inimigo próximo, dando um dano físico de 669 e o mantém em estado de choque durante 15 segundos.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 16,
        name: "Marca do Perseguidor",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 57,
                cast: 0,
                info:
                    "Durante 12 segundos reduz o crítico e a evasão do alvo em 5 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 10%.",
                necessaryLevel: 38,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 68,
                cast: 0,
                info:
                    "Durante 14 segundos reduz o crítico e a evasão do alvo em 7 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 12%.",
                necessaryLevel: 42,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 80,
                cast: 0,
                info:
                    "Durante 16 segundos reduz o crítico e a evasão do alvo em 9 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 14%.",
                necessaryLevel: 46,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 94,
                cast: 0,
                info:
                    "Durante 18 segundos reduz o crítico e a evasão do alvo em 11 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 16%.",
                necessaryLevel: 50,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 109,
                cast: 0,
                info:
                    "Durante 20 segundos reduz o crítico e a evasão do alvo em 13 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 18%.",
                necessaryLevel: 54,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 126,
                cast: 0,
                info:
                    "Durante 22 segundos reduz o crítico e a evasão do alvo em 15 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 20%.",
                necessaryLevel: 58,
            },
            {
                level: 7,
                cooldown: 6,
                mp: 143,
                cast: 0,
                info:
                    "Durante 24 segundos reduz o crítico e a evasão do alvo em 17 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 22%.",
                necessaryLevel: 62,
            },
            {
                level: 8,
                cooldown: 6,
                mp: 161,
                cast: 0,
                info:
                    "Durante 26 segundos reduz o crítico e a evasão do alvo em 19 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 23%.",
                necessaryLevel: 66,
            },
            {
                level: 9,
                cooldown: 6,
                mp: 180,
                cast: 0,
                info:
                    "Durante 28 segundos reduz o crítico e a evasão do alvo em 21 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 24%.",
                necessaryLevel: 70,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 203,
                cast: 0,
                info:
                    "Durante 30 segundos reduz o crítico e a evasão do alvo em 25 pontos. Aumenta a taxa de HP limite do Eliminar o Alvo em 25%.",
                necessaryLevel: 74,
            },
        ],
    },
    {
        logoId: 17,
        name: "Demolição X-14",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 362,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 40 no terreno selecionado atcando os inimigos automaticamente durante um período de 40 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 422,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 44 no terreno selecionado atcando os inimigos automaticamente durante um período de 42 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 493,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 48 no terreno selecionado atcando os inimigos automaticamente durante um período de 44 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 566,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 52 no terreno selecionado atcando os inimigos automaticamente durante um período de 46 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 650,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 56 no terreno selecionado atcando os inimigos automaticamente durante um período de 48 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 739,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 60 no terreno selecionado atcando os inimigos automaticamente durante um período de 50 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 822,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 64 no terreno selecionado atcando os inimigos automaticamente durante um período de 52 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 914,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 68 no terreno selecionado atcando os inimigos automaticamente durante um período de 54 segundos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 1018,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 72 no terreno selecionado atcando os inimigos automaticamente durante um período de 56 segundos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 1126,
                cast: 3,
                info:
                    "Instala uma sentinela de nível 76 no terreno selecionado atcando os inimigos automaticamente durante um período de 60 segundos.",
                necessaryLevel: 76,
            },
        ],
    },
    {
        logoId: 18,
        name: "Contra-Golpe",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 611,
                cast: 3,
                info:
                    "Inflige 1409 de dano físico, sugando um máximo de 1071 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 50 pontos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 722,
                cast: 3,
                info:
                    "Inflige 1665 de dano físico, sugando um máximo de 1257 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 52 pontos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 851,
                cast: 3,
                info:
                    "Inflige 1962 de dano físico, sugando um máximo de 1475 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 54 pontos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 987,
                cast: 3,
                info:
                    "Inflige 2277 de dano físico, sugando um máximo de 1704 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 56 pontos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 1143,
                cast: 3,
                info:
                    "Inflige 2637 de dano físico, sugando um máximo de 1965 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 58 pontos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 90,
                mp: 1313,
                cast: 3,
                info:
                    "Inflige 3015 de dano físico, sugando um máximo de 2249 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 60 pontos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 90,
                mp: 1476,
                cast: 3,
                info:
                    "Inflige 3407 de dano físico, sugando um máximo de 2517 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 62 pontos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 90,
                mp: 1660,
                cast: 3,
                info:
                    "Inflige 3830 de dano físico, sugando um máximo de 2815 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 64 pontos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 90,
                mp: 1866,
                cast: 3,
                info:
                    "Inflige 4307 de dano físico, sugando um máximo de 3152 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 66 pontos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 90,
                mp: 2087,
                cast: 3,
                info:
                    "Inflige 4815 de dano físico, sugando um máximo de 3507 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 68 pontos.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 90,
                mp: 2317,
                cast: 3,
                info:
                    "Inflige 5346 de dano físico, sugando um máximo de 3878 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 70 pontos.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 90,
                mp: 2574,
                cast: 3,
                info:
                    "Inflige 5940 de dano físico, sugando um máximo de 4287 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 72 pontos.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 90,
                mp: 2859,
                cast: 3,
                info:
                    "Inflige 6597 de dano físico, sugando um máximo de 4739 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 74 pontos.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 90,
                mp: 3175,
                cast: 3,
                info:
                    "Inflige 7263 de dano físico, sugando um máximo de 5240 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 76 pontos.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 90,
                mp: 3526,
                cast: 3,
                info:
                    "Inflige 7992 de dano físico, sugando um máximo de 5792 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 78 pontos.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 90,
                mp: 3815,
                cast: 3,
                info:
                    "Inflige 8802 de dano físico, sugando um máximo de 6243 de MP e adiciona como dano extra. A skill possui um acerto crítico adicional de 80 pontos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 19,
        name: "Ataque Atordoante",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 266,
                cast: 0,
                info:
                    "Causa 512 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 51,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 308,
                cast: 0,
                info:
                    "Causa 593 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 55,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 353,
                cast: 0,
                info:
                    "Causa 686 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 402,
                cast: 0,
                info:
                    "Causa 773 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 451,
                cast: 0,
                info:
                    "Causa 867 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 508,
                cast: 0,
                info:
                    "Causa 977 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 569,
                cast: 0,
                info:
                    "Causa 1094 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 631,
                cast: 0,
                info:
                    "Causa 1214 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 702,
                cast: 0,
                info:
                    "Causa 1350 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 779,
                cast: 0,
                info:
                    "Causa 1499 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 87,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 866,
                cast: 0,
                info:
                    "Causa 1665 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 91,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 961,
                cast: 0,
                info:
                    "Causa 1848 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 1068,
                cast: 0,
                info:
                    "Causa 2054 de dano físico e mantém o alvo atordoado por 3 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 20,
        name: "Ultimato",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 100 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 55,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 150 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 59,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 200 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 63,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 250 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 67,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 300 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 71,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 350 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 75,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 400 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 79,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 450 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 83,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 500 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 87,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Atacando um inimigo com o HP abaixo de 25% causa um dano adicional de 550 pontos e aumenta a sua velocidade em 2 pontos.",
                necessaryLevel: 91,
            },
        ],
    },
    {
        logoId: 21,
        name: "Posição de Atirador",
        levelsInfo: [
            {
                level: 1,
                cooldown: 150,
                mp: 1150,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 20 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 59,
            },
            {
                level: 2,
                cooldown: 150,
                mp: 1282,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 21 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 63,
            },
            {
                level: 3,
                cooldown: 150,
                mp: 1426,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 22 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 67,
            },
            {
                level: 4,
                cooldown: 150,
                mp: 1586,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 23 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 71,
            },
            {
                level: 5,
                cooldown: 150,
                mp: 1759,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 24 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 75,
            },
            {
                level: 6,
                cooldown: 150,
                mp: 1932,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 25 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 79,
            },
            {
                level: 7,
                cooldown: 150,
                mp: 2124,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 26 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 83,
            },
            {
                level: 8,
                cooldown: 150,
                mp: 2334,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 27 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 87,
            },
            {
                level: 9,
                cooldown: 150,
                mp: 2562,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 28 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 91,
            },
            {
                level: 10,
                cooldown: 150,
                mp: 2813,
                cast: 0,
                info:
                    "Se oculta entre as sombras permitindo atacar os inimigos durante 30 segundos, porém reduz a velocidade de movimento em 50 e a habilidade é desativada ao receber algum ataque. Reseta a habilitade Ocultar.",
                necessaryLevel: 95,
            },
        ],
    },
    {
        logoId: 22,
        name: "Visão Acurada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 404,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 2 habilidades.",
                necessaryLevel: 61,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 450,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 3 habilidades.",
                necessaryLevel: 65,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 501,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 4 habilidades.",
                necessaryLevel: 69,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 557,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 5 habilidades.",
                necessaryLevel: 73,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 614,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 6 habilidades.",
                necessaryLevel: 77,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 675,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 7 habilidades.",
                necessaryLevel: 81,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 741,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 8 habilidades.",
                necessaryLevel: 85,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 814,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 9 habilidades.",
                necessaryLevel: 89,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 894,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 10 habilidades.",
                necessaryLevel: 93,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 982,
                cast: 1,
                info:
                    "Sua visão impecável te permitirá acertar todas as habilidades nos alvos, ignorando bloqueios. Efeito termina após 2 minutos ou uso de 12 habilidades.",
                necessaryLevel: 97,
            },
        ],
    },
    {
        logoId: 23,
        name: "Guarda Fatal",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 3 pontos cada.",
                necessaryLevel: 65,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 6 pontos cada.",
                necessaryLevel: 69,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 9 pontos cada.",
                necessaryLevel: 73,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 12 pontos cada.",
                necessaryLevel: 77,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 15 pontos cada.",
                necessaryLevel: 81,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 18 pontos cada.",
                necessaryLevel: 85,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 21 pontos cada.",
                necessaryLevel: 89,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 24 pontos cada.",
                necessaryLevel: 93,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 27 pontos cada.",
                necessaryLevel: 97,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a resistência ao ataque crítico e ao ataque duplo em 30 pontos cada.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 24,
        name: "Golpe Fantasma",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 1004,
                cast: 3,
                info:
                    "Causa 2575 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 490 de dano extra por ataque durante 6 segundos. A habilidade possui uma taxa crítico adicional de 25.",
                necessaryLevel: 69,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 1130,
                cast: 3,
                info:
                    "Causa 2898 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 522 de dano extra por ataque durante 6 segundos. A habilidade possui uma taxa crítico adicional de 27.",
                necessaryLevel: 73,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 1258,
                cast: 3,
                info:
                    "Causa 3226 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 614 de dano extra por ataque durante 6 segundos. A habilidade possui uma taxa crítico adicional de 29.",
                necessaryLevel: 77,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 1399,
                cast: 3,
                info:
                    "Causa 3587 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 683 de dano extra por ataque durante 7 segundos. A habilidade possui uma taxa crítico adicional de 31.",
                necessaryLevel: 81,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 1553,
                cast: 3,
                info:
                    "Causa 3982 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 758 de dano extra por ataque durante 8 segundos. A habilidade possui uma taxa crítico adicional de 33.",
                necessaryLevel: 85,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 1725,
                cast: 3,
                info:
                    "Causa 4423 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 842 de dano extra por ataque durante 9 segundos. A habilidade possui uma taxa crítico adicional de 35.",
                necessaryLevel: 89,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 1915,
                cast: 3,
                info:
                    "Causa 4910 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 935 de dano extra por ataque durante 10 segundos. A habilidade possui uma taxa crítico adicional de 37.",
                necessaryLevel: 93,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 2128,
                cast: 3,
                info:
                    "Causa 5456 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 1039 de dano extra por ataque durante 11 segundos. A habilidade possui uma taxa crítico adicional de 39.",
                necessaryLevel: 97,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 2243,
                cast: 3,
                info:
                    "Causa 5750 de dano físico nos inimigos dentro de 4M de um alvo. Cada golpe acrescenta 1095 de dano extra por ataque durante 12 segundos. A habilidade possui uma taxa crítico adicional de 41.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 25,
        name: "Inspirar Matança",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 677,
                cast: 0,
                info:
                    "Causa 1302 de dano físico e converte 80% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 25% do HP máximo.",
                necessaryLevel: 71,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 758,
                cast: 0,
                info:
                    "Causa 1458 de dano físico e converte 85% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 30% do HP máximo.",
                necessaryLevel: 75,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 841,
                cast: 0,
                info:
                    "Causa 1618 de dano físico e converte 90% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 35% do HP máximo.",
                necessaryLevel: 79,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 936,
                cast: 0,
                info:
                    "Causa 1800 de dano físico e converte 95% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 40% do HP máximo.",
                necessaryLevel: 83,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 1039,
                cast: 0,
                info:
                    "Causa 1998 de dano físico e converte 100% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 45% do HP máximo.",
                necessaryLevel: 87,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 1154,
                cast: 0,
                info:
                    "Causa 2220 de dano físico e converte 105% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 50% do HP máximo.",
                necessaryLevel: 91,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 1281,
                cast: 0,
                info:
                    "Causa 2464 de dano físico e converte 110% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 55% do HP máximo.",
                necessaryLevel: 95,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 1424,
                cast: 0,
                info:
                    "Causa 2738 de dano físico e converte 120% desse valor para recuperação de HP. Se o alvo for morto por esta habilidade, recupera HP adicional equivalente a 60% do HP máximo.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 26,
        name: "Sentença de Morte",
        levelsInfo: [
            {
                level: 1,
                cooldown: 30,
                mp: 1327,
                cast: 1,
                info:
                    "Causa 2552 de dano físico e tem 39% de matar um monstro elite instantaneamente. Possibilidade de 26% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 75,
            },
            {
                level: 2,
                cooldown: 30,
                mp: 1473,
                cast: 1,
                info:
                    "Causa 2832 de dano físico e tem 45% de matar um monstro elite instantaneamente. Possibilidade de 30% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 79,
            },
            {
                level: 3,
                cooldown: 30,
                mp: 1638,
                cast: 1,
                info:
                    "Causa 3150 de dano físico e tem 51% de matar um monstro elite instantaneamente. Possibilidade de 34% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 83,
            },
            {
                level: 4,
                cooldown: 30,
                mp: 1818,
                cast: 1,
                info:
                    "Causa 3497 de dano físico e tem 57% de matar um monstro elite instantaneamente. Possibilidade de 38% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 87,
            },
            {
                level: 5,
                cooldown: 30,
                mp: 2020,
                cast: 1,
                info:
                    "Causa 3885 de dano físico e tem 63% de matar um monstro elite instantaneamente. Possibilidade de 42% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 91,
            },
            {
                level: 6,
                cooldown: 30,
                mp: 2242,
                cast: 1,
                info:
                    "Causa 4312 de dano físico e tem 69% de matar um monstro elite instantaneamente. Possibilidade de 46% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 95,
            },
            {
                level: 7,
                cooldown: 30,
                mp: 2492,
                cast: 1,
                info:
                    "Causa 4792 de dano físico e tem 75% de matar um monstro elite instantaneamente. Possibilidade de 50% da habilidade  causar dano duplo em um jogador.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 27,
        name: "Postura Fantasma",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 1157,
                cast: 0,
                info:
                    "Ao ativar a skill, inflige 2225 de dano físico e o usuário esconde-se nas sombras durante 6 segundos ganhando velocidade de movimento em 10.",
                necessaryLevel: 79,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 1287,
                cast: 0,
                info:
                    "Ao ativar a skill, inflige 2475 de dano físico e o usuário esconde-se nas sombras durante 6 segundos ganhando velocidade de movimento em 10.",
                necessaryLevel: 83,
            },
            {
                level: 3,
                cooldown: 90,
                mp: 1428,
                cast: 0,
                info:
                    "Ao ativar a skill, inflige 2747 de dano físico e o usuário esconde-se nas sombras durante 6 segundos ganhando velocidade de movimento em 10.",
                necessaryLevel: 87,
            },
            {
                level: 4,
                cooldown: 90,
                mp: 1588,
                cast: 0,
                info:
                    "Ao ativar a skill, inflige 3053 de dano físico e o usuário esconde-se nas sombras durante 6 segundos ganhando velocidade de movimento em 10.",
                necessaryLevel: 91,
            },
            {
                level: 5,
                cooldown: 90,
                mp: 1762,
                cast: 0,
                info:
                    "Ao ativar a skill, inflige 3388 de dano físico e o usuário esconde-se nas sombras durante 6 segundos ganhando velocidade de movimento em 10.",
                necessaryLevel: 95,
            },
            {
                level: 6,
                cooldown: 90,
                mp: 1958,
                cast: 0,
                info:
                    "Ao ativar a skill, inflige 3765 de dano físico e o usuário esconde-se nas sombras durante 6 segundos ganhando velocidade de movimento em 10.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 28,
        name: "Explosão Napalm",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 1332,
                cast: 0,
                info:
                    "Atira uma bala que aquece o chão causando 2562 de dano físico aos inimigos dentro de um raio de 6M e derrete suas defesas por 10 segundos.",
                necessaryLevel: 81,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 1479,
                cast: 0,
                info:
                    "Atira uma bala que aquece o chão causando 2844 de dano físico aos inimigos dentro de um raio de 6M e as suas defesas são derretidas por 12 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 1643,
                cast: 0,
                info:
                    "Atira uma bala que aquece o chão causando 3159 de dano físico aos inimigos dentro de um raio de 6M e as suas defesas são derretidas por 14 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 1824,
                cast: 0,
                info:
                    "Atira uma bala que aquece o chão causando 3507 de dano físico aos inimigos dentro de um raio de 6M e as suas defesas são derretidas por 16 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 2026,
                cast: 0,
                info:
                    "Atira uma bala que aquece o chão causando 3897 de dano físico aos inimigos dentro de um raio de 6M e as suas defesas são derretidas por 18 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 2136,
                cast: 0,
                info:
                    "Atira uma bala que aquece o chão causando 4107 de dano físico aos inimigos dentro de um raio de 6M e as suas defesas são derretidas por 20 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 29,
        name: "Armadilha Múltipla",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 1327,
                cast: 0,
                info:
                    "Causa 1896 de dano físico no alvo e inimigos próximos num raio de 6M, diminuindo o movimento em 18 por 4 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 2,
                cooldown: 55,
                mp: 1474,
                cast: 0,
                info:
                    "Causa 2106 de dano físico no alvo e inimigos próximos num raio de 6M, diminuindo o movimento em 21 por 5 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 3,
                cooldown: 50,
                mp: 1637,
                cast: 0,
                info:
                    "Causa 2338 de dano físico no alvo e inimigos próximos num raio de 6M, diminuindo o movimento em 24 por 6 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 4,
                cooldown: 45,
                mp: 1819,
                cast: 0,
                info:
                    "Causa 2598 de dano físico no alvo e inimigos próximos num raio de 6M, diminuindo o movimento em 27 por 7 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 1917,
                cast: 0,
                info:
                    "Causa 2738 de dano físico no alvo e inimigos próximos num raio de 6M, diminuindo o movimento em 30 por 8 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 30,
        name: "Choro de Chumbo",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 1630,
                cast: 1,
                info:
                    "Coloca chumbo no tambor da arma e aumenta seu poder por  8 segundos adicionando 14 de taxa dupla, ignorando 24% da defesa do inimigo e causando dano em área a inimigos próximos equivalente a 80% do ataque físico.",
                necessaryLevel: 89,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 1790,
                cast: 1,
                info:
                    "Coloca chumbo no tambor da arma e aumenta seu poder por  8 segundos adicionando 16 de taxa dupla, ignorando 26% da defesa do inimigo e causando dano em área a inimigos próximos equivalente a 80% do ataque físico.",
                necessaryLevel: 93,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 1966,
                cast: 1,
                info:
                    "Coloca chumbo no tambor da arma e aumenta seu poder por  8 segundos adicionando 18 de taxa dupla, ignorando 28% da defesa do inimigo e causando dano em área a inimigos próximos equivalente a 80% do ataque físico.",
                necessaryLevel: 97,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 2060,
                cast: 1,
                info:
                    "Coloca chumbo no tambor da arma e aumenta seu poder por  8 segundos adicionando 20 de taxa dupla, ignorando 30% da defesa do inimigo e causando dano em área a inimigos próximos equivalente a 80% do ataque físico.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 31,
        name: "Destino",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 2494,
                cast: 1,
                info:
                    "Ao atirar em um inimigo com uma bala especial, ignora completamente sua defesa física e inflige 2587 de dano físico. Adiciona 4312 de dano extra ao usar a habilidade enquanto está oculto.",
                necessaryLevel: 95,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 2771,
                cast: 1,
                info:
                    "Ao atirar em um inimigo com uma bala especial, ignora completamente sua defesa física e inflige 2875 de dano físico. Adiciona 4792 de dano extra ao usar a habilidade enquanto está oculto.",
                necessaryLevel: 99,
            },
        ],
    },
]
